'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _connectOptionsFromStore = require('./connectOptionsFromStore');

var _connectOptionsFromStore2 = _interopRequireDefault(_connectOptionsFromStore);

var _fetchOptionsOnInputChange = require('./fetchOptionsOnInputChange');

var _fetchOptionsOnInputChange2 = _interopRequireDefault(_fetchOptionsOnInputChange);

var _complementOptions = require('./complementOptions');

var _complementOptions2 = _interopRequireDefault(_complementOptions);

var _moveFullMatchFirst = require('./moveFullMatchFirst');

var _moveFullMatchFirst2 = _interopRequireDefault(_moveFullMatchFirst);

var _sortOptions = require('./sortOptions');

var _sortOptions2 = _interopRequireDefault(_sortOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  schema: (0, _propTypes.shape)({
    type: _propTypes.string.isRequired,
    reference: _propTypes.string,
    lazyFetch: _propTypes.bool,
    options: _propTypes.array
  }),
  reference: _propTypes.string,
  lazyFetch: _propTypes.bool,
  options: _propTypes.array,
  multi: _propTypes.bool,
  filterOptions: _propTypes.func
}), (0, _injectProps2.default)({
  value: _propTypes.any
}),

// handle multi-select schema, select the schema of option
(0, _branch2.default)(function (_ref) {
  var schema = _ref.schema;
  return !!schema;
}, (0, _withProps2.default)(function (_ref2) {
  var schema = _ref2.schema;

  if (schema.type === 'Array') {
    return {
      multi: true,
      schema: schema.contents[0]
    };
  }
  return {};
})),

// ISSUE flatten twice
(0, _flattenDefaultProp2.default)('schema'),

// decide options source
(0, _branch2.default)(function (_ref3) {
  var reference = _ref3.reference;
  return !!reference;
}, (0, _branch2.default)(function (_ref4) {
  var lazyFetch = _ref4.lazyFetch;
  return !lazyFetch;
}, _connectOptionsFromStore2.default, _fetchOptionsOnInputChange2.default), (0, _withProps2.default)(function (_ref5) {
  var options = _ref5.options;
  return { options: options };
})), (0, _withPropsOnChange2.default)(['options', 'filterOptions'], function (_ref6) {
  var options = _ref6.options,
      filterOptions = _ref6.filterOptions;
  return {
    options: filterOptions ? filterOptions(options) : options
  };
}),

// handle selected value,
_complementOptions2.default,

// sort options by @order
_sortOptions2.default,

// select full match option first rather than sub-match option
_moveFullMatchFirst2.default, (0, _exposeProps2.default)(['multi', 'schema', 'options', 'onInputChange']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'processOptions');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/index.js
// module id = 1638
// module chunks = 0